import { Box, Link, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { OGCIcon } from "@nens/ranalib";
import { useFrontendSetting } from "@nens/ranalib";

import { ContentPanel } from "@/components/content-panel";

import { ProjectFileStatus } from "./project-file-status";

export const ProjectFilePreviewOGC = () => {
  const { desktopClientVersion } = useFrontendSetting();
  const fileName = `RanaDesktopClient-OSGeo4W-${desktopClientVersion}-Setup-x86_64.exe`;
  return (
    <ProjectFileStatus icon={OGCIcon}>
      <Box mt={6}>
        <ContentPanel p={8} m={3} overflow="hidden" bg="brand.cloudy" color="brand.analytic">
          <FormattedMessage
            id="projectfile.ogc_3d_tiles_explanation"
            defaultMessage="OGC 3D Tiles is an OGC community standard designed for streaming and rendering massive 3D geospatial content."
          />
          <Text>
            <FormattedMessage
              id="projectfile.ogc_3d_tiles_water_levels"
              defaultMessage="This file <strong>shows water levels in a 3D format</strong>, ready to use in applications that support this format."
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </Text>
          <br />
          <Text>
            <FormattedMessage
              id="projectfile.projectfile.ogc_3d_tiles_application"
              defaultMessage="If you don't have an application in which you'd like to use the format you can use the {rana_desktop_client} to preview the file."
              values={{
                rana_desktop_client: (
                  <Link
                    textDecor="underline"
                    isExternal
                    href={`https://downloads.ranawaterintelligence.com/${fileName}`}
                    fontWeight="bold"
                  >
                    <FormattedMessage
                      id="projectfile.rana_desktop_client"
                      defaultMessage="Rana Desktop Client"
                    />
                  </Link>
                ),
              }}
            />
          </Text>
        </ContentPanel>
      </Box>
    </ProjectFileStatus>
  );
};
